// src-dev/ts/components/menu.ts

export function initMenu(): void {
    const hamburger = document.getElementById('hamburger');
    const body = document.body;
  
    if (!hamburger) return;
  
    hamburger.addEventListener('click', () => {
      body.classList.toggle('menu-open');
    });
  
    document.querySelectorAll<HTMLAnchorElement>('.mobile-menu a').forEach(link => {
      link.addEventListener('click', () => {
        body.classList.remove('menu-open');
      });
    });
  }